module.exports = __webpack_public_path__ + "img/status0_icon2.3a8f1294.png";